import { ENV } from '../config';

/**
 * Appends `publicationState=preview` to the URL if the environment is `preproduction`.
 * @param url The original URL.
 * @returns The modified URL with `publicationState=preview` if applicable.
 */
export const applyPreproductionSettings = (url: string): string => {
  if (ENV === 'preproduction') {
    return url.includes('?') ? `${url}&publicationState=preview` : `${url}?publicationState=preview`;
  }
  return url;
};
